// extracted by mini-css-extract-plugin
export default {"container":"Te7NxC","viewer":"s2byUR","truncated":"xmc852","expandTransition":"vfbgGT","shrinkTransition":"UDO5zm","showMore":"fsIBwx"};